import { render, staticRenderFns } from "./AdminPage.vue?vue&type=template&id=316cf2b4"
import script from "./AdminPage.vue?vue&type=script&lang=js"
export * from "./AdminPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/code/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('316cf2b4')) {
      api.createRecord('316cf2b4', component.options)
    } else {
      api.reload('316cf2b4', component.options)
    }
    module.hot.accept("./AdminPage.vue?vue&type=template&id=316cf2b4", function () {
      api.rerender('316cf2b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/AdminPage.vue"
export default component.exports